'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var TimeCache = require('time-cache');

var pull = require('pull-stream');

var lp = require('pull-length-prefixed');

var assert = require('assert');

var BaseProtocol = require('./base');

var utils = require('./utils');

var pb = require('./message');

var config = require('./config');

var multicodec = config.multicodec;
var ensureArray = utils.ensureArray;

var setImmediate = require('async/setImmediate');
/**
 * FloodSub (aka dumbsub is an implementation of pubsub focused on
 * delivering an API for Publish/Subscribe, but with no CastTree Forming
 * (it just floods the network).
 */


var FloodSub =
/*#__PURE__*/
function (_BaseProtocol) {
  _inherits(FloodSub, _BaseProtocol);

  /**
   * @param {Object} libp2p
   * @constructor
   */
  function FloodSub(libp2p) {
    var _this;

    _classCallCheck(this, FloodSub);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FloodSub).call(this, 'libp2p:floodsub', multicodec, libp2p));
    /**
     * Time based cache for sequence numbers.
     *
     * @type {TimeCache}
     */

    _this.cache = new TimeCache();
    /**
     * List of our subscriptions
     * @type {Set<string>}
     */

    _this.subscriptions = new Set();
    return _this;
  }

  _createClass(FloodSub, [{
    key: "_onDial",
    value: function _onDial(peerInfo, conn, callback) {
      var _this2 = this;

      _get(_getPrototypeOf(FloodSub.prototype), "_onDial", this).call(this, peerInfo, conn, function (err) {
        if (err) return callback(err);
        var idB58Str = peerInfo.id.toB58String();

        var peer = _this2.peers.get(idB58Str);

        if (peer && peer.isWritable) {
          // Immediately send my own subscriptions to the newly established conn
          peer.sendSubscriptions(_this2.subscriptions);
        }

        setImmediate(function () {
          return callback();
        });
      });
    }
  }, {
    key: "_processConnection",
    value: function _processConnection(idB58Str, conn, peer) {
      var _this3 = this;

      pull(conn, lp.decode(), pull.map(function (data) {
        return pb.rpc.RPC.decode(data);
      }), pull.drain(function (rpc) {
        return _this3._onRpc(idB58Str, rpc);
      }, function (err) {
        return _this3._onConnectionEnd(idB58Str, peer, err);
      }));
    }
  }, {
    key: "_onRpc",
    value: function _onRpc(idB58Str, rpc) {
      if (!rpc) {
        return;
      }

      this.log('rpc from', idB58Str);
      var subs = rpc.subscriptions;
      var msgs = rpc.msgs;

      if (msgs && msgs.length) {
        this._processRpcMessages(utils.normalizeInRpcMessages(rpc.msgs));
      }

      if (subs && subs.length) {
        var peer = this.peers.get(idB58Str);

        if (peer) {
          peer.updateSubscriptions(subs);
          this.emit('floodsub:subscription-change', peer.info, peer.topics, subs);
        }
      }
    }
  }, {
    key: "_processRpcMessages",
    value: function _processRpcMessages(msgs) {
      var _this4 = this;

      msgs.forEach(function (msg) {
        var seqno = utils.msgId(msg.from, msg.seqno); // 1. check if I've seen the message, if yes, ignore

        if (_this4.cache.has(seqno)) {
          return;
        }

        _this4.cache.put(seqno); // 2. emit to self


        _this4._emitMessages(msg.topicIDs, [msg]); // 3. propagate msg to others


        _this4._forwardMessages(msg.topicIDs, [msg]);
      });
    }
  }, {
    key: "_emitMessages",
    value: function _emitMessages(topics, messages) {
      var _this5 = this;

      topics.forEach(function (topic) {
        if (!_this5.subscriptions.has(topic)) {
          return;
        }

        messages.forEach(function (message) {
          _this5.emit(topic, message);
        });
      });
    }
  }, {
    key: "_forwardMessages",
    value: function _forwardMessages(topics, messages) {
      var _this6 = this;

      this.peers.forEach(function (peer) {
        if (!peer.isWritable || !utils.anyMatch(peer.topics, topics)) {
          return;
        }

        peer.sendMessages(utils.normalizeOutRpcMessages(messages));

        _this6.log('publish msgs on topics', topics, peer.info.id.toB58String());
      });
    }
    /**
     * Unmounts the floodsub protocol and shuts down every connection
     *
     * @param {Function} callback
     * @returns {undefined}
     *
     */

  }, {
    key: "stop",
    value: function stop(callback) {
      var _this7 = this;

      _get(_getPrototypeOf(FloodSub.prototype), "stop", this).call(this, function (err) {
        if (err) return callback(err);
        _this7.subscriptions = new Set();
        callback();
      });
    }
    /**
     * Publish messages to the given topics.
     *
     * @param {Array<string>|string} topics
     * @param {Array<any>|any} messages
     * @returns {undefined}
     *
     */

  }, {
    key: "publish",
    value: function publish(topics, messages) {
      var _this8 = this;

      assert(this.started, 'FloodSub is not started');
      this.log('publish', topics, messages);
      topics = ensureArray(topics);
      messages = ensureArray(messages);
      var from = this.libp2p.peerInfo.id.toB58String();

      var buildMessage = function buildMessage(msg) {
        var seqno = utils.randomSeqno();

        _this8.cache.put(utils.msgId(from, seqno));

        return {
          from: from,
          data: msg,
          seqno: seqno,
          topicIDs: topics
        };
      };

      var msgObjects = messages.map(buildMessage); // Emit to self if I'm interested

      this._emitMessages(topics, msgObjects); // send to all the other peers


      this._forwardMessages(topics, msgObjects);
    }
    /**
     * Subscribe to the given topic(s).
     *
     * @param {Array<string>|string} topics
     * @returns {undefined}
     */

  }, {
    key: "subscribe",
    value: function subscribe(topics) {
      var _this9 = this;

      assert(this.started, 'FloodSub is not started');
      topics = ensureArray(topics);
      topics.forEach(function (topic) {
        return _this9.subscriptions.add(topic);
      });
      this.peers.forEach(function (peer) {
        return sendSubscriptionsOnceReady(peer);
      }); // make sure that FloodSub is already mounted

      function sendSubscriptionsOnceReady(peer) {
        if (peer && peer.isWritable) {
          return peer.sendSubscriptions(topics);
        }

        var onConnection = function onConnection() {
          peer.removeListener('connection', onConnection);
          sendSubscriptionsOnceReady(peer);
        };

        peer.on('connection', onConnection);
        peer.once('close', function () {
          return peer.removeListener('connection', onConnection);
        });
      }
    }
    /**
     * Unsubscribe from the given topic(s).
     *
     * @param {Array<string>|string} topics
     * @returns {undefined}
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(topics) {
      var _this10 = this;

      // Avoid race conditions, by quietly ignoring unsub when shutdown.
      if (!this.started) {
        return;
      }

      topics = ensureArray(topics);
      topics.forEach(function (topic) {
        return _this10.subscriptions.delete(topic);
      });
      this.peers.forEach(function (peer) {
        return checkIfReady(peer);
      }); // make sure that FloodSub is already mounted

      function checkIfReady(peer) {
        if (peer && peer.isWritable) {
          peer.sendUnsubscriptions(topics);
        } else {
          setImmediate(checkIfReady.bind(peer));
        }
      }
    }
  }]);

  return FloodSub;
}(BaseProtocol);

module.exports = FloodSub;